import { Switch } from "antd";
import { FullSubStatusName } from "../fullSubStatusName/fullSubStatusName";
import { OutgoingTransitionIcon } from "../../outgoingTransitionIcon/outgoingTransitionIcon";
import styles from "./outgoingTransitionItem.module.scss";

export const OutgoingTransitionItem = ({
  statusName,
  subStatusName,
  isActive,
  showToggle,
  onToggle,
}) => {
  return (
    <div
      className={`${styles.outgoingTransitionItem} ${
        !isActive ? styles.disabled : ""
      }`}
    >
      <OutgoingTransitionIcon />

      <FullSubStatusName statusName={statusName}>
        {subStatusName}
      </FullSubStatusName>

      {showToggle && (
        <Switch
          checked={isActive}
          onChange={onToggle}
          style={{ marginLeft: "auto" }}
        />
      )}
    </div>
  );
};
